/**
 * HeartbeatContext
 *
 * Shares the BPM pulse state across the whole app so HeartbeatBar instances
 * everywhere (nav, hero, footer) all move in unison.
 */
import { createContext, useContext } from "react";

export interface HeartbeatState {
  bpm: number;
  isListening: boolean;
  isHeartbeat: boolean;
  toggleMic: () => void;
}

export const HeartbeatContext = createContext<HeartbeatState>({
  bpm: 70,
  isListening: false,
  isHeartbeat: false,
  toggleMic: () => {},
});

export function useHeartbeat() {
  return useContext(HeartbeatContext);
}
